// tslint:disable: max-classes-per-file

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthService } from '@fry/lib/auth';
import { BaseMenuService, MenuItem } from '@fry/lib/menu';
import { SecurityService } from '@fry/lib/security';
import { RemoteUserService } from '@fry/lib/users';
import { map } from 'rxjs/operators';

const baseMenu = [
  {
    id: 'users',
    link: '/users',
    title: $localize `Users`,
    parent: 'user-management'
  },
];

const remoteMenu: MenuItem[] = [
  {
    id: 'summary',
    link: '/users/:user/dashboard',
    title: $localize `Summary`,
  },
];

@Injectable()
export class UsersMenu extends BaseMenuService {

    constructor(auth: AuthService, security: SecurityService) {
        super(auth, security);
    }

    cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            of([{
              id: 'user-management',
              title: $localize `User management`
            }]),
            this.menuWithPermission(baseMenu, 'users.view')
        );
    }
}

@Injectable()
export class UsersRemoteMenu extends BaseMenuService {

    constructor(protected auth: AuthService,
                protected security: SecurityService,
                private remoteUser: RemoteUserService) {
        super(auth, security);

        this.startUpdating();
    }

    cook(): Observable<MenuItem[]> {
        return this.mergeItems(
            this.menuWithPermission(remoteMenu, 'users.view')
        ).pipe(
          map(items => {
            if (!this.remoteUser.user) { return []; }
            return items.map(item => {
              return {
                ...item,
                link: item.link.replace(/:user/, this.remoteUser.user.doc.user),
              };
            });
          })
        );
    }

    public startUpdating() {
        if (!this.remoteUser) { return; }
        this.remoteUser.user$.subscribe(user => {
          console.log(user);
          if (user) {
            this.updateMenu();
          }
        });
    }
}
